import { TransportOption } from '../types/logistics';
import { apiService } from './apiService';

class TransportService {
  private cache: TransportOption[] = [];

  async getTransportOptions(forceRefresh = false): Promise<TransportOption[]> {
    if (!forceRefresh && this.cache.length > 0) {
      return this.cache;
    }

    try {
      const options = await apiService.get<TransportOption[]>('/logistics/transport');
      this.cache = options || [];
      return this.cache;
    } catch (error) {
      console.error('Error fetching transport options:', error);
      return [];
    }
  }

  async getTransportOptionById(id: string): Promise<TransportOption | null> {
    try {
      return await apiService.get<TransportOption>(`/logistics/transport/${id}`);
    } catch (error) {
      console.error(`Error fetching transport option ${id}:`, error);
      return null;
    }
  }

  async createTransportOption(data: Omit<TransportOption, 'id' | 'createdAt' | 'updatedAt'>): Promise<TransportOption | null> {
    try {
      const newOption = await apiService.post<TransportOption>('/logistics/transport', data);
      this.cache = [];
      return newOption;
    } catch (error) {
      console.error('Error creating transport option:', error);
      return null;
    }
  }

  async updateTransportOption(id: string, data: Partial<TransportOption>): Promise<TransportOption | null> {
    try {
      const updated = await apiService.put<TransportOption>(`/logistics/transport/${id}`, data);
      this.cache = [];
      return updated;
    } catch (error) {
      console.error(`Error updating transport option ${id}:`, error);
      return null;
    }
  }

  async deleteTransportOption(id: string): Promise<boolean> {
    try {
      await apiService.delete(`/logistics/transport/${id}`);
      this.cache = [];
      return true;
    } catch (error) {
      console.error(`Error deleting transport option ${id}:`, error);
      return false;
    }
  }
}

export const transportService = new TransportService();
